import { getAssetPath } from 'lib/utils/common/commonUtils'

export const ASSET_PREFIX = `${getAssetPath()}/static/img/pages/press`

export const BANNER_SRC = {
  en: {
    desktop: {
      src: `${ASSET_PREFIX}/pressBannerWeb.jpg`,
      ratio: 0.540714286,
    },
    mobile: {
      src: `${ASSET_PREFIX}/pressBannerMobile.jpg`,
      ratio: 1.77777778,
    },
  },
}

export const BANNER_TEXT = {
  title: 'Hi There!',
  titleKey: 'PRESS_PAGE_HEADER_TITLE',
  subtitle: "All of the write-ups, images, and details you'll ever need.",
  subtitleKey: 'PRESS_PAGE_HEADER_SUBTITLE',
}
